import axios from 'axios'
import K from './k'

export default class Services {
  constructor(that) {
    this.that = that
    this.base_url = K.baseUrl
  }
  deg2rad = (deg) => {
    return deg * (Math.PI / 180)
  }
  getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371 // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1) // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1)
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = Math.round(R * c) // Distance in km
    return d
  }

  getHeaders = async () => {
    const token = await localStorage.getItem('jhi-authenticationToken')
    return {
      Authorization: 'Bearer ' + token,
      'Content-type': 'application/json',
    }
  }

  token = localStorage.getItem('user-token')
  user_id = localStorage.getItem('user_id')
  user = JSON.parse(localStorage.getItem('user'))

  getHistory = async (data) => {
    data = {
      client_id: this.user_id,
      apiToken: this.token,
    }
    return this.post(K.view_history_url, data)
  }

  getPrepMealHistory = async (data) => {
    data = {
      client_id: this.user_id,
      user_id: this.user_id,
      apiToken: this.token,
    }
    return this.post(K.scheduled_orders_url, data)
  }

  getOrder = async (order_id, prepMeal) => {
    const data = {
      client_id: this.user_id,
      apiToken: this.token,
      order_id: order_id,
      prepMeal: prepMeal,
    }
    return this.post(K.track_order_url, data)
  }

  updateUser = async (data) => {
    data['id'] = this.user_id
    data['apiToken'] = this.token
    return this.post(K.update_user_url, data)
  }
  rateItem = async (data) => {
    data['client_id'] = this.user_id
    data['apiToken'] = this.token
    return this.post(K.rating_url, data)
  }
  updateRating = async (data) => {
    data['client_id'] = this.user_id
    data['apiToken'] = this.token
    return this.post(K.update_rating_url, data)
  }

  fetchUser = async () => {
    const data = {
      client_id: this.user_id,
      apiToken: this.token,
    }
    const url = `${K.fetchuser_url}/${this.user_id}/${this.token}`
    return this.get(url, data)
  }
  signupPartner = async (data) => {
    return this.post(K.signup_partner_url, data)
  }

  contactUs = async (data) => {
    return this.post(K.contact_us_url, data)
  }
  getDriver = async (orderId, prepMeal) => {
    const data = {
      apiToken: this.token,
      client_id: this.user_id,
      id: orderId,
      prepMeal: prepMeal,
    }
    return this.post(K.get_driver_url, data)
  }

  get = async (url) => {
    const headers = await this.getHeaders()
    return axios
      .get(url, headers)
      .then((resp) => {
        return resp.data
      })
      .catch()
  }

  post = async (url, data) => {
    const headers = await this.getHeaders()
    return axios
      .post(url, data, headers)
      .then((resp) => {
        return resp.data
      })
      .catch((error) => {
        console.log(error)
      })
  }

  getRequestOptions = (token) => {
    return {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-type': 'application/json',
      },
    }
  }

  postRequestOptions = (token, item) => {
    return {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-type': 'application/json',
      },
      body: JSON.stringify(item),
    }
  }
}
